import { CartView, CartGroupView, CTLineItem } from '../types/cartTypes';
import { updateCart } from '../utils/cartUtil';

export async function removeItem(
  contextItem: CartGroupView | CTLineItem,
  existingCart: CartView | null = null
): Promise<CartView | null> {
  const actions: Array<{ action: string; lineItemId: string }> = [];

  if ('mainItem' in contextItem && contextItem.mainItem && Array.isArray(contextItem.addOns)) {
    const itemsToRemove = [contextItem.mainItem, ...contextItem.addOns];
    itemsToRemove.forEach((item) => {
      actions.push({ action: 'removeLineItem', lineItemId: item.id });
    });
  } else if ('id' in contextItem && contextItem.id) {
    actions.push({ action: 'removeLineItem', lineItemId: contextItem.id });
  }

  return updateCart(actions, existingCart);
}
